import { QueryCache, QueryClient } from '@tanstack/react-query';

export const createQueryClient = () => {
	return new QueryClient({
		queryCache: new QueryCache({
			onError: (error: any) => {
				// ZodError indicates API contract mismatch - always log
				if (error.name === 'ZodError') {
					console.error('Zod Validation Error Details:', error);
					return;
				}

				// Skip non-actionable errors that flood Datadog with noise
				const isNetworkError = error.message === 'Network Error';
				const is401 = error.response?.status === 401;

				if (isNetworkError || is401) {
					// These are expected/transient - don't alert on them
					return;
				}

				// Log everything else (5xx, unexpected 4xx, etc.)
				console.error('React Query Error:', {
					message: error.message,
					stack: error.stack,
					name: error.name,
				});
			},
		}),
		defaultOptions: {
			queries: {
				// This needs to be higher than the persistence maxAge otherwise it will just remove the
				// stored data as soon as it's loaded
				cacheTime: 48 * 60 * 60 * 1000,
				keepPreviousData: true,
				retry: false,
				staleTime: 10 * 60 * 1000,
			},
		},
	});
};
